module.exports = __webpack_public_path__ + "img/left_3_hover.abdda7e6.png";